/* eslint-disable no-nested-ternary */
import React, { useMemo, useCallback } from 'react';
import { Select } from '@iq/react-components';
import './SelectWidget.scss';

const SelectWidget = (props) => {
  const {
    disabled,
    readonly,
    required,
    formContext,
    value,
    schema: {
      default: defaultValue,
      isMulti,
      isClearable,
      noOptionsMessage,
      extraText,
      extraTextTriggers = [],
      extraTextKey,
      placeholder: schemaPlaceholder,
      editable = true,
      groupedOptions,
    },
    options: { enumOptions = [] },
    onChange,
    ...otherProps
  } = props;
  const getLabel = (val) => enumOptions.find((o) => o.value === val)?.label;

  const theValue = useMemo(() => {
    if (isMulti) {
      let coercedValue = value;
      if (!Array.isArray(value)) {
        coercedValue = [value];
      }

      return (coercedValue || []).map((v) => ({
        label: enumOptions.find((o) => o.value === v)?.label,
        value: v,
      }));
    }
    if (value || value === 0) {
      return { label: getLabel(value), value };
    }
    if (defaultValue) {
      return { label: getLabel(defaultValue), value: defaultValue };
    }
    return undefined;
  }, [value, defaultValue, enumOptions]);

  const setValues = useCallback(
    (selected) => {
      if (isMulti) {
        onChange((selected || []).map((s) => s.value));
      } else {
        onChange(selected?.value || selected?.value === 0 ? selected.value : null);
      }
    },
    [onChange, isMulti]
  );

  const triggeredExtraTextKeys = useMemo(() => {
    let coercedValue = value || [];
    if (!Array.isArray(value)) {
      coercedValue = [value];
    }
    return [...new Set(coercedValue).intersection(new Set(extraTextTriggers))];
  }, [value]);

  const getEmptyMsg = (text) => <div>{text}</div>;

  const overrideStyles = {
    container: (base) => ({ ...base, lineHeight: 'normal' }),
    singleValue: (base) => ({ ...base, lineHeight: 'normal' }),
    control: (base) => ({ ...base, lineHeight: 'normal' }),
  };

  const options =
    groupedOptions ||
    enumOptions.map((opt) => {
      const cleanedOpt = { ...opt };
      delete cleanedOpt.schema;
      return cleanedOpt;
    });

  return editable ? (
    <>
      {extraTextKey ? <div className="extra-text">{extraText[extraTextKey]}</div> : null}
      {triggeredExtraTextKeys.map((k, i) => {
        const key = `extra-text-${i}`;
        return (
          <div
            key={key}
            className="extra-text"
          >
            {extraText[k]}
          </div>
        );
      })}
      <Select
        {...otherProps}
        key={`unique_select_key`}
        className="schema-select-widget"
        isMulti={isMulti}
        isClearable={isClearable}
        closeMenuOnSelect={!isMulti}
        isDisabled={disabled}
        readOnly={readonly}
        required={required}
        placeholder={schemaPlaceholder}
        menuPlacement="auto"
        value={theValue}
        onChange={setValues}
        options={options}
        noOptionsMessage={() => getEmptyMsg(noOptionsMessage || 'No options')}
        styles={overrideStyles}
      />
    </>
  ) : (
    <>
      {theValue instanceof Array ? (
        theValue.map((val, i) => {
          const key = `${val}-${i}`;
          return (
            <div
              key={key}
              className="view-widget-multi"
            >
              <label className="view-widget">{`${val.label}`}</label>
            </div>
          );
        })
      ) : (
        <label className="view-widget">{`${theValue?.label}`}</label>
      )}
    </>
  );
};

export default SelectWidget;
